import { ChangeDetectionStrategy, Component, Inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Environment } from '@uc/utilities';

@Component({
	selector: 'uc-navigation-tabs',
	templateUrl: './navigation-tabs.component.html',
	imports: [RouterLink, RouterLinkActive],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationTabsComponent {
	postExclusive = input.required<boolean>();
	selectedTab = input.required<string>();
	isPreview = input.required<boolean>();
	uniSlug = input.required<string>();
	clearingEnabled!: boolean;

	constructor(@Inject('environment') protected environment: Environment) {
		this.clearingEnabled = environment.clearingEnabled;
	}

	isRouteActive(): boolean {
		return this.isPreview() && this.selectedTab() === 'undergraduate' ? false : true;
	}
}
